const interview_nav = () => {
  var navLinks = document.querySelectorAll('.p-interview__content .c-nav__page a');
  if(navLinks != null) {
    navLinks.forEach(function(link) {
        link.addEventListener('click', function(event) {
            event.preventDefault();
            document.querySelectorAll('.c-nav__page li').forEach(function(li) {
                li.classList.remove('is-active');
            });
            var filter = link.getAttribute('data-filter');
            var items = document.querySelectorAll('.p-interview__list > .p-interview__list__item');

            items.forEach(function(item) {
                if(item.classList.contains(filter)) {
                    item.style.display = 'block';
                } else {
                    item.style.display = 'none';
                }
            });
            link.closest('li').classList.add('is-active');
        });
    });
  }
};
